export default "__VITE_ASSET__GMAN0ESJ__"